import React, { useState } from 'react';

import { FILTER_RELATIONS } from '../../helpers/constants';

import AppBar from '../../../../base/components/AppBar/AppBar';
import Filters from './components/Filters/Filters';
import MainPageCharts from './components/MainPageCharts/MainPageCharts';

import styles from './CommunityDashboardPage.module.css';

export default props => {
  const { isAdmin } = props;
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterRelation, setFilterRelation] = useState(FILTER_RELATIONS.AND);
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);

  if (!isAdmin) return null;

  return (
    <div>
      <AppBar {...props} />
      <div className={styles.container}>
        <div className={styles.title}>Community dashboard</div>
        <Filters
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          filterRelation={filterRelation}
          setFilterRelation={setFilterRelation}
          isGlobalLoading={isGlobalLoading}
        />
        <MainPageCharts
          appliedFilters={appliedFilters}
          filterRelation={filterRelation}
          isGlobalLoading={isGlobalLoading}
          setIsGlobalLoading={setIsGlobalLoading}
        />
      </div>
    </div>
  );
};
